exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slick-dots{position:unset;margin:1em 0}.slick-dots li{margin:0}.slick-dots .slick-active>div>div,.slick-dots li:hover>div>div{background-color:#9196af}.slick-prev{left:-120px}.slick-next{right:-120px}.slick-disabled svg{color:rgba(255,255,255,.5);-webkit-transition:.3s;transition:.3s}.arrow-38oAc{font-size:1rem;margin-right:0;width:120px;display:unset;height:100%;border-radius:0;position:absolute}.arrow-38oAc:before{content:none}.dotWrapper-1LDJf{width:100%;height:100%}.dotWrapper-1LDJf .dot-3Ulce{width:10px;height:10px;border:1px solid #9196af;border-radius:50%;position:relative;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);margin-right:0}.slide-Tn0xQ{position:relative;outline:none}.sliderModal-1Cyux{background-color:rgba(0,0,0,0);max-width:100%;width:1280px}.sliderOverlay-3xNJ2{background-color:rgba(0,0,0,.9);padding:40px 80px}.modalContent-3vi7b{padding-top:40px}", ""]);

// exports
exports.locals = {
	"arrow": "arrow-38oAc",
	"dotWrapper": "dotWrapper-1LDJf",
	"dot": "dot-3Ulce",
	"slide": "slide-Tn0xQ",
	"sliderModal": "sliderModal-1Cyux",
	"sliderOverlay": "sliderOverlay-3xNJ2",
	"modalContent": "modalContent-3vi7b"
};